import { DeletableValueOnUnmountSingleSelectCheckboxGroup } from 'app/components/Form/Fields';
import { RAMQContextElements } from 'shared/ramq/RamqContextElements';
import PATIENT_NO_SHOW from 'shared/ramq/requiredDetails/patientNoShow';

interface ListValue {
  label: string;
  value: boolean;
}

const getList = (date: number) => {
  const ramqContextElement100 = RAMQContextElements.get('100', date);
  const list: ListValue[] = [];
  if (ramqContextElement100) {
    list.push({ label: 'Patient non-présenté', value: true });
  }
  return list;
};

const getAssociatedFields = (date: number) => {
  const ramqContextElement100 = RAMQContextElements.get('100', date);
  if (!ramqContextElement100) {
    return [];
  }

  return {
    associatedFields: [
      {
        label: '',
        getName: (index) => `codes[${index}].${PATIENT_NO_SHOW}`,
        list: getList(date),
        notRequired: true,
        type: DeletableValueOnUnmountSingleSelectCheckboxGroup
      }
    ]
  };
};

export default getAssociatedFields;
